import styled from "styled-components";

type ImageProps = {
  $img: string;
};

export const Container = styled.div`
  margin: 0 auto;
  margin-top: 10px;
  padding: 0;
  display: flex;
  width: 100%;
  gap: 0px;
  border-radius: 50px;
  border: 1px solid black;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  @media (max-width: 430px) {
    padding: 5px;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    width: 373px;
  }
`;

export const DivLink = styled.div`
  display: flex;
  gap: 25px;
  align-items: center;
  @media (max-width: 430px) {
    display: none;
  }
`;
export const Div = styled.div`
  display: flex;
  gap: 25px;
  align-items: center;
`;

export const HeaderContainer = styled.header`
  position: relative;
  margin: 10px;
  font-family: Avenir Next;
  @media (max-width: 430px) {
    width: 373px;
  }
`;

export const Summary = styled.summary`
  padding: 0;
  margin: 0;
  font-family: Avenir Next;
  margin-left: 25px;
  outline: none;
  list-style: none;
  &::-webkit-details-marker {
    display: none;
  }
`;

export const P = styled.div`
  margin: 0;
  padding: 0;
  display: block;
  font-family: Avenir Next;

  &:hover {
    color: #1983ff;
  }
`;

export const PContainer1 = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 25px;
  font-family: Avenir Next;
  background-color: #dddee4;
  border-radius: 20px;
  padding: 10px;
  width: 470px;
`;
export const PContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 25px;
  font-family: Avenir Next;
  background-color: #dddee4;
  border-radius: 20px;
  padding: 10px;
  width: 150px;
`;

export const Dropdown1 = styled.details`
  margin: 0;
  padding: 0;
  position: absolute;
  display: block;
  font-family: Avenir Next;
  font-size: 22px;
  cursor: pointer;
  padding: 5px;
  margin-top: 15px;
  border-radius: 20px;
  z-index: 10;
  @media (max-width: 430px) {
    display: none;
  }
`;

export const Dropdown2 = styled.details`
  margin: 0;
  padding: 0;
  position: absolute;
  display: block;
  font-family: Avenir Next;
  font-size: 22px;
  cursor: pointer;
  padding: 5px;
  margin: 5px;
  border-radius: 20px;
  z-index: 10;
  margin-top: 15px;
  &::marker {
    display: none;
  }
  right: 325px;
  @media (max-width: 430px) {
    display: none;
  }
`;

export const Question = styled.a`
  padding: 5px 10px;
  background-color: #bfdcf5;
  color: black;
  border: 1px solid black;
  cursor: pointer;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  margin: 0;
  text-decoration: none;

  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
  }
  @media (max-width: 430px) {
    display: none;
  }
`;

export const Points = styled.a`
  display: block;
  font-family: Avenir Next;
`;

export const DropdownInfo = styled.div`
  display: none;
  font-family: Avenir Next;
`;

export const Link1 = styled.div`
  display: block;
  font-family: Avenir Next;
  font-size: 22px;
  cursor: pointer;
  margin-left: 155px;
`;

export const Burger = styled.div<ImageProps>`
  display: none;
  cursor: pointer;
  width: 48px;
  height: 48px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  align-items: center;
  @media (max-width: 430px) {
    display: block;
    margin-top: 27px;
  }
`;
export const Link2 = styled.div<ImageProps>`
  display: none;
  cursor: pointer;
  width: 36px;
  height: 36px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  align-items: center;
  background-image: center;
  @media (max-width: 430px) {
    display: block;
    margin-top: 3px;
    margin-left: 5px;
  }
`;

export const Link = styled.div`
  display: block;
  font-family: Avenir Next;
  font-size: 22px;
  cursor: pointer;
  text-decoration: none;
  @media (max-width: 430px) {
    display: none;
  }
`;

export const SearchSmall = styled.img`
  position: absolute;
  cursor: pointer;
  width: 50px;
  height: 50px;
  margin-top: 5px;
  left: 0;
`;
export const LogoSmall = styled.img`
  cursor: pointer;
  width: 140px;
  height: 32px;
  margin-top: 20px;
`;
export const Logo = styled.img`
  cursor: pointer;
  width: 250px;
  height: 32px;
  padding-right: 100px;
  @media (max-width: 430px) {
    width: 140px;
    padding: 0;
  }
`;

export const SearchContainer = styled.div`
  background-color: #55749f;
  display: none;
  margin: 0;
  padding: 0;
  top: -10px;
  left: -10px;
  position: absolute;
  width: 100%;
  height: 1080px;
  z-index: 10000;
`;

export const SmallHeaderContainer = styled.div`
  /* z-index: 10000; */
  background-color: #55749f;
  display: flex;
  flex-direction: column;
  width: 394px;
  height: 100vh;
  margin: 20px;
`;
export const SmallHeaderConsult = styled.div`
  text-decoration: none;
  color: white;
  margin-left: 20px;
  font-size: 25px;
`;
export const SmallHeaderLink = styled.a`
  text-decoration: none;
  color: white;
  margin-left: 20px;
  font-size: 18px;
`;
export const SmallHeaderBigs = styled.a`
  text-decoration: none;
  color: white;
  margin-left: 20px;
  font-size: 30px;
`;
export const SmallHeaderQuestion = styled.a`
  height: 50px;
  padding: 15px 130px;
  gap: 0px;
  border-radius: 30px;
  background-color: rgba(255, 255, 255, 1);
  color: rgba(85, 116, 159, 1);
  text-decoration: none;
  margin: 10px;
  margin-top: 130px;
`;
export const SmallHeaderQuestion2 = styled.a`
  height: 50px;
  padding: 15px 70px;
  gap: 0px;
  border-radius: 30px;
  border: 1px solid white;
  color: white;
  text-decoration: none;
  margin: 10px;
`;

export const LinksContainer = styled.a`
  margin: 0 auto;
  margin-top: 20px;
`;
export const Links = styled.a`
  font-family: Avenir Next;
  font-weight: 500;
  text-align: center;
  color: white;
  text-decoration: none;
`;

export const InnerSearchContainerSmall = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #55749f;
  width: 100%;
  height: 1080px;
  @media (max-width: 430px) {
    width: 394px;
  }
`;
export const InnerSearchContainer = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #55749f;
  width: 100%;
  height: 100vh;
  @media (max-width: 430px) {
    width: 394px;
  }
`;

export const XSearch = styled.div<ImageProps>`
  position: absolute;
  z-index: 5000;
  cursor: pointer;
  display: block;
  margin-left: 1350px;
  width: 50px;
  height: 50px;
  top: 50px;
  color: white;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  align-items: center;

  @media (max-width: 430px) {
    margin-left: 340px;
    top: 10px;
  }
`;

export const SearchText = styled.div`
  font-family: Avenir Next;
  font-weight: 400;
  font-size: 18px;
  text-align: left;
  color: white;
  margin-left: -800px;
  margin-top: 60px;
`;

export const SearchBarContainer = styled.div`
  display: flex;
`;

export const AllResults = styled.ul`
  list-style-type: none;
  width: 850px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  @media (max-width: 430px) {
    width: 340px;
  }
`;

export const Result = styled.a`
  font-family: Avenir Next;
  font-size: 25px;
  font-weight: 400;
  text-align: left;
  color: #cccccc;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: white;
  }
  @media (max-width: 430px) {
    font-size: 18px;
  }
`;

export const SearchBar = styled.input`
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: left;
  border: none;
  border-bottom: 1px solid white;
  background-color: transparent;
  color: white;
  width: 800px;
  &::placeholder {
    color: white;
    opacity: 0.5;
  }
  &:focus {
    outline: none;
  }
  &:active {
    outline: none;
  }
  @media (max-width: 430px) {
    width: 270px;
    margin-right: 20px;
    font-size: 18px;
  }
`;

export const SearchImg = styled.img`
  height: 50px;
  width: 50px;
  border-radius: 30px;
  cursor: pointer;
`;
